"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OfficeCommercialFitouts() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    title: "Executive Offices & Suites",
    description: "High-status workspaces with premium finishes, soundproofing, and ergonomic design.",
    image: "https://theksway.com/wp-content/uploads/2026/04/Executive-Offices-Suite.webp?v=ypajqcvzsdg"
  }, {
    id: 2,
    title: "Turn-Key Commercial\nFit-Outs",
    description: "Complete project management — from design and construction to final delivery.",
    image: "https://theksway.com/wp-content/uploads/2026/04/Turn-Key-Commercial-Fit-Outs.webp?v=hdjqd9e789"
  }, {
    id: 3,
    title: "Corporate Renovations",
    description: "Offices, retail spaces, and professional environments built for performance and longevity.",
    image: "https://theksway.com/wp-content/uploads/2026/04/Corporate-Renovations.webp?v=f83l3u7h767"
  }];
  return <section id="office-commercial-fitouts" ref={sectionRef} className="relative w-full overflow-hidden bg-[#161616] ![padding:96px_0px_96px_0px]">
      <div className="container mx-auto max-w-[1400px] px-10">
        {}
        <div className={`mx-auto mb-16 max-w-3xl text-center transition-all duration-[var(--duration-slow)] ${sectionVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="mb-4 flex items-center justify-center gap-4 text-xs font-medium uppercase tracking-[0.125rem] text-[#C69A59]">
            <span className="!text-[hsl(32,29%,42%)]">OFFICE & COMMERCIAL RENOVATIONS</span>
            
            
          </div>

          <h2 className="mb-6 font-display font-semibold leading-tight text-white !text-5xl">Office & Commercial <br /> Fit‑Outs</h2>

          <p className="text-lg leading-relaxed text-white/80">We create professional environments that reflect brand identity, efficiency, and confidence. From concept to handover, we manage every stage of the project. Commercial services include:</p>
        </div>

        {}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => <div key={service.id} data-index={i} className={`group relative overflow-hidden rounded-xl bg-[#1a1a1a] shadow-[0_4px_16px_rgb(0_0_0_/_0.3)] transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-[0_8px_32px_rgb(198_154_89_/_0.25),_0_0_40px_rgb(198_154_89_/_0.15)] ${sectionVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
          transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
        }}>
              {}
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img src={service.image} alt={service.title} className="size-full object-cover grayscale transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105 group-hover:grayscale-0" />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent opacity-60" />
              </div>

              {}
              <div className="p-8">
                <h3 className="whitespace-pre-line mb-4 font-display text-2xl font-semibold text-white">
                  {service.title}
                </h3>
                <p className="mb-6 leading-relaxed text-white/70">
                  {service.description}
                </p>

                <Link to="#" className="inline-block">
                  
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}